<template>

  <div v-bind:class="get_width('board')" v-bind:key="pos[1]">
    <div class="hit-panel hit-panel-primary">
      <div class="hit-panel-heading">
        <div class="hit-pull-right">{{ $tc("message.board", 1) }}</div>
        <span class="handle"><i class="hit-glyphicon hit-glyphicon-move"></i></span>
      </div>
      <div class="hit-panel-body" style="background-color: lightgrey;">
        <div class="hit-form-group">

          <hit_survey v-bind:key="curr_key+'_survey'" class="hit-html-html" :design="design.survey" :survey="Object.assign(board[$route.params.boardID], {colors: colors})"/>

        </div>
      </div>
      <div class="hit-panel-footer hit-text-right">
        <div class="hit-row">
          <div class="hit-col-md-6 hit-col-md-hit-offset-6">
            <select class="hit-form-control" v-bind:value="width['board']" v-on:change="function(val){ set_width(val.target.value, 'board') }">
              <option v-for="col in [12,11,10,9,8,7,6,5,4,3,2,1]" v-bind:value="col">{{ Math.round((col/12 * 100)) }}%</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default{

  props: {
    width: Object,
    set_width: Function,
    board: Object,
    colors: Object,
    design: Object,
    curr_key: [String, Number],
    get_width: Function,
    get_badge: Function,
    pos: Array

  }
}

</script>

<style scoped>

.handle{
  cursor: pointer;
}

</style>
